// This is just some sample data so you don't have to think of your own!
export const Stores = [
  {
    name: "2 Kitchens",
    tagline: "insert witty tagline here",
    image: require("./images/Logo 2Kitchens.png"),
    address: "8 Stowe Street",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/2Kitchens")
  },

  {
    name: "Bingo",
    tagline: "insert witty tagline here",
    image: require("./images/Bingo Logo.jpg"),
    address: "5 Sir Lowry Road",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/Bingo")
  },

  {
    name: "Cyber Cellar",
    tagline: "insert witty tagline here",
    image: require("./images/Cybercellar.jpg"),
    address: "175 Victoria Road",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/CyberCellar")
  },

  {
    name: "Fat Cactus",
    tagline: "insert witty tagline here",
    image: require("./images/fat cactus final logo.jpg"),
    address: "160 Albert Road",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/FatCactus")
  },

  {
    name: "Fishaways",
    tagline: "insert witty tagline here",
    image: require("./images/fishaways_tag.png"),
    address: "169 Victoria Road",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/Fishaways")
  },

  {
    name: "Truck Food Mafia",
    tagline: "insert witty tagline here",
    image: require("./images/food truck mafia logo new.png"),
    address: "19 Kent Street",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/FoodTruckMafia")
  },

  {
    name: "Jamaica Me Crazy",
    tagline: "insert witty tagline here",
    image: require("./images/Jamaica Me Crazy.jpg"),
    address: "74 Roodebloem Road",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/JamaicaMeCrazy")
  },

  {
    name: "Three Feathers Diner",
    tagline: "insert witty tagline here",
    image: require("./images/Three Feathers Diner.jpg"),
    address: "86 Bromwell Street",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/ThreeFeathersDiner")
  },

  {
    name: "Yum",
    tagline: "insert witty tagline here",
    image: require("./images/yum logo.png"),
    address: "31 Brickfield Road",
    tel: "000-000-000",
    menu: require("./sample-stores-menus/Yum")
  }
];



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores.js